import React from "react";
import styled from "styled-components";
import LifeAtTextInput from "@common/LifeAtTextInput/LifeAtTextInput";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import Styles from "@themes/Styles";

const UserEmailWrapper = styled.span<{ canEdit: boolean }>`
    min-height: 30px;
    height: auto;

    padding: 4px;

    border: 1px solid ${(props) => props.theme.borderPrimary};
    border-radius: ${Styles.borderRadiusSharp};

    cursor: ${(props) => (props.canEdit ? "text" : "not-allowed")};
`;

/**
 * NOTE: users cannot edit their email address.
 * @constructor
 */
export function UserEmailSetting() {
    const { user }: UserContextType = useUserContext();

    return (
        <UserEmailWrapper canEdit={false}>
            <LifeAtTextInput
                textValue={user.email}
                isEditing={false}
                finishEditCallback={() => {}} // we do not allow editing email address
                handleUpdate={() => {}}
            />
        </UserEmailWrapper>
    );
}
